import { Button, cn } from '@heroui/react'
import { useBillingStatusStore } from '@qse/stores'
import { AlertTriangle, X } from 'lucide-react'
import { useEffect, useState } from 'react'

interface PaymentOverdueBannerProps {
  className?: string
  isInView?: boolean
  setIsPaymentVisible?: (show: boolean) => void
}

export const PaymentOverdueBanner: React.FC<PaymentOverdueBannerProps> = ({
  className,
  isInView = true,
  setIsPaymentVisible,
}) => {
  const { showPaymentOverdueBanner, setShowPaymentOverdueBanner } = useBillingStatusStore()

  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    // Add a small delay for smooth animation
    const timer = setTimeout(() => {
      setIsVisible(showPaymentOverdueBanner)
      setIsPaymentVisible?.(showPaymentOverdueBanner)
    }, 0)

    return () => clearTimeout(timer)
  }, [showPaymentOverdueBanner])

  if (!isVisible) {
    return null
  }

  return (
    <div
      className={cn(
        'border relative border-red-200 mb-4 bg-red-500/10 dark:border-red-800 rounded-lg shadow-sm transform transition-all duration-300 ease-in-out',
        isVisible ? 'translate-y-0 opacity-100' : '-translate-y-full opacity-0',
        isInView ? 'lg:w-1/2' : '',
        className,
      )}
    >
      <div className="px-4 py-3">
        <div className="flex flex-row gap-4">
          <div className="flex items-center gap-3 flex-1">
            <div className="flex-shrink-0">
              <AlertTriangle className="w-5 h-5 text-red-500 dark:text-[#DD524C]" />
            </div>
            <div className="flex-1">
              <p className="lg:text-sm text-xs font-medium text-red-900 dark:text-red-100 ">
                Payment Overdue - Your account payment is past due. Service access may be terminated
                at any time. Please update your payment method or contact support to avoid service
                interruption
              </p>
            </div>
          </div>
          <Button
            isIconOnly
            className=" absolute -right-2 -top-2 min-w-6 min-h-6 w-6 h-6"
            color="danger"
            radius="full"
            size="sm"
            onPress={() => setShowPaymentOverdueBanner(false)}
          >
            <X className="w-5 h-5 " />
          </Button>
        </div>
      </div>
    </div>
  )
}
